import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useRequestHandler from './useRequestHandler'

import { clearUpdateRight, setRightUploadAdData, updateRight } from '../../../../modules/actions/rights'
import {
  rightSelector,
  updateRightWasUpdatedSelector,
  updateRightErrorSelector,
  rightUploadAdDataCampaignSelector
} from '../../../../modules/selectors/rights'
import { lineItemsErrorSelector, lineItemsWasLoadedSelector } from '../../../../modules/selectors/lineItems'
import { campaignCreateSelector } from '../../../../modules/selectors/campaigns'

import { PLATFORMS_TO_PROVIDER } from '../../../../constants/selectLists/platformList'
import { OPTION_EXISTING_LIST_ITEM, OPTION_NEW_LIST_ITEM } from '../../../../hooks/formHooks/listItemFormHooks/fields'

export default function useSuccessCampaignFormSubmit({ campaignOption, platform, adAccountId, shouldFetchLineItems }) {
  const [successSubmit, setSuccessSubmit] = useState(false)

  const dispatch = useDispatch()

  const right = useSelector(rightSelector)

  const lineItemsWasLoaded = useSelector(lineItemsWasLoadedSelector)
  const lineItemsError = useSelector(lineItemsErrorSelector)
  const campaignCreateData = useSelector(campaignCreateSelector)

  const rightUploadAdDataCampaign = useSelector(rightUploadAdDataCampaignSelector(platform))

  const { id: rightId, campaigns: rightCampaigns } = right

  const updateRightRequest = useCallback(() => {
    dispatch(
      updateRight(rightId, {
        campaigns: [
          {
            ad_account_id: adAccountId,
            external_id: campaignCreateData.id,
            provider: PLATFORMS_TO_PROVIDER[platform]
          },
          ...(rightCampaigns ? rightCampaigns : [])
        ]
      })
    )
  }, [dispatch, rightId, adAccountId, campaignCreateData, platform, rightCampaigns])

  useRequestHandler({
    successRequestSelector: updateRightWasUpdatedSelector,
    errorRequestSelector: updateRightErrorSelector,
    clearRequestAction: clearUpdateRight,
    clearOnUmount: false
  })

  // handle success submit of existing campaign case - load line items data for selected campaign
  useEffect(() => {
    if (
      campaignOption === OPTION_EXISTING_LIST_ITEM &&
      rightUploadAdDataCampaign &&
      (shouldFetchLineItems ? lineItemsWasLoaded || lineItemsError : true)
    ) {
      setSuccessSubmit(true)
    }
  }, [
    campaignOption,
    lineItemsError,
    lineItemsWasLoaded,
    setSuccessSubmit,
    rightUploadAdDataCampaign,
    shouldFetchLineItems
  ])

  // handle success submit of new campaign case - update right, push campaign to combined campaigns list
  useEffect(() => {
    if (campaignOption === OPTION_NEW_LIST_ITEM && campaignCreateData.id && !successSubmit) {
      // manually update right with create campaign (it was decided not to track status of this request)
      updateRightRequest()

      dispatch(setRightUploadAdData({ campaign: campaignCreateData }, platform))

      setSuccessSubmit(true)
    }
  }, [successSubmit, campaignCreateData, campaignOption, dispatch, setSuccessSubmit, platform, updateRightRequest])

  return useMemo(() => successSubmit, [successSubmit])
}
